import React from 'react';
import MyBreakdownsPanel from '../../maintenance/MyBreakdownsPanel';
import { SELF_SERVICE, WidgetDef } from './types';

// Self-service: the widget lists only the signed-in user's own breakdown reports (the endpoint takes no
// permission key), so it carries no key gate (SELF_SERVICE) like the personal board sections; only
// the module filter hides it when the institution has maintenance switched off.
export const maintenanceWidgets: WidgetDef[] = [
    {
        id: 'my-breakdowns',
        module: 'maintenance',
        title: 'Machine breakdowns',
        subtitle: 'Problems you reported',
        permission: SELF_SERVICE,
        size: 'md',
        component: () => <MyBreakdownsPanel />,
    },
];
